import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Text, TextInput, View, Dimensions, Platform, ScrollView, StyleSheet } from 'react-native';
import { Picker } from '@react-native-picker/picker';
import { FamilyInfoFormProps } from './FamilyInfoFormProps';

import Colors from '../../../constants/Colors';
import Layout from '../../../constants/Layout';
import FilledButton from '../../FilledButton';
import HouseholdSize from '../../form/HouseholdSize/HouseholdSize';

class FamilyInfoForm extends Component {
  static propTypes = {
    goNext: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    translation: PropTypes.objectOf(PropTypes.any).isRequired,
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  /**
   * @param {FamilyInfoFormProps} props
   */
  constructor(props) {
    super();
    const { translation } = props;
    this.state = {
      adult_family_members: props.registration.user.adult_family_members || 0,
      child_family_members: props.registration.user.child_family_members || 0,
      senior_family_members: props.registration.user.senior_family_members || 0,
      labels: {
        note_title: translation.fragment_registration_family_textview_notetitle,
        note_content: translation.fragment_registration_family_textview_notecontent,
        next: translation.fragment_registration_family_button_next,
        back: translation.fragment_registration_family_button_back,
      },
    };
  }

  dropdownValues = [
    <Picker.Item key="Select-Item-0" label="0" value={0} />,
    <Picker.Item key="Select-Item-1" label="1" value={1} />,
    <Picker.Item key="Select-Item-2" label="2" value={2} />,
    <Picker.Item key="Select-Item-3" label="3" value={3} />,
    <Picker.Item key="Select-Item-4" label="4" value={4} />,
    <Picker.Item key="Select-Item-5" label="5" value={5} />,
    <Picker.Item key="Select-Item-6" label="6" value={6} />,
  ];

  onChange = (field, value) => {
    const state = this.state;
    state[field] = value;
    this.setState(state);
  };

  submitForm = () => {
    const { registration, goNext } = this.props;
    const { user } = registration;
    Object.keys(this.state).forEach((field) => {
      if (field !== 'labels') user[field] = this.state[field];
    });
    return goNext(user);
  };

  render() {
    const { goBack, registration } = this.props;
    const { labels } = this.state;

    return (
      <View style={styles.container}>
        <View style={styles.topRow}>
          <ScrollView keyboardShouldPersistTaps="handled">
            <HouseholdSize
              familyMemberCounts={{
                adultFamilyMembers: this.state['adult_family_members'] ?? 0,
                childFamilyMembers: this.state['child_family_members'] ?? 0,
                seniorFamilyMembers: this.state['senior_family_members'] ?? 0,
              }}
              state={registration.user.state}
              zipcode={registration.user.zip_code}
              language={registration.language}
              labelStyle={styles.familyLabel}
              onChange={(key, value) => {
                this.onChange(key, value);
              }}
            ></HouseholdSize>
            <View>
              <Text style={styles.textRow}>
                <Text style={styles.noteTitle}>{labels.note_title}</Text>
                <Text style={styles.noteContent}>{labels.note_content}</Text>
              </Text>
            </View>
          </ScrollView>
        </View>
        <View style={styles.buttonRow}>
          <View style={[styles.button, styles.leftButton]}>
            <FilledButton
              onPress={goBack}
              label={labels.back}
              color={Colors.darkGreen}
              full={false}
              testID="button-back"
            />
          </View>
          <View style={styles.button}>
            <FilledButton
              onPress={this.submitForm}
              label={labels.next}
              color={Colors.darkGreen}
              full
              testID="button-next"
            />
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    padding: Layout.isSmall ? 16 : 0,
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  topRow: {
    flex: 1,
  },
  inputField: {
    height: 60,
    marginTop: 10,
  },
  dropdown: {
    width: Dimensions.get('window').width - 24,
    maxWidth: 384,
    height: 30,
    borderColor: Colors.white,
  },
  dropdownPlaceholder: {
    color: Colors.grayText,
    fontFamily: 'roboto-regular',
  },
  icon: {
    color: Colors.lightGray,
  },
  buttonRow: {
    marginTop: 20,
    marginBottom: 20,
    flexDirection: 'row',
  },
  button: {
    flex: 1,
  },
  buttonText: {
    color: Colors.white,
    fontSize: 14,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  leftButton: {
    marginRight: 16,
  },
  textRow: {
    marginTop: 40,
    marginBottom: 40,
    lineHeight: 20,
    borderColor: Colors.accentColor,
    borderWidth: 1,
    borderRadius: 8,
    padding: 12,
  },
  noteTitle: {
    fontWeight: '600',
    fontFamily: 'roboto-regular',
  },
  noteContent: {
    fontFamily: 'roboto-regular',
  },
});

export default FamilyInfoForm;
